exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".time-picker-container {\n  margin: 0 20px;\n  padding: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  /*justify-content: center;*/ }\n  .time-picker-container span {\n    padding: 0 26px;\n    color: #666; }\n  .time-picker-container .time-picker {\n    margin: 0px; }\n    .time-picker-container .time-picker input {\n      border: 1px solid #b2b2b2;\n      width: 30px;\n      height: 30px;\n      font-size: 0.8rem;\n      text-align: center;\n      margin: 0 5px; }\n    .time-picker-container .time-picker span {\n      padding: 0 10px;\n      color: #666; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/time-picker/time-picker.component.scss
// module id = 1322
// module chunks = 0